export const environment = {
  production: true,
  //databaseID: 5, // psp
  //databaseID: 8, // capital lake
  //databaseID: 14, // oakland
  //databaseID: 17, // wind
  //databaseID: 25, // cpuc
  //databaseID: 36, // duck2
  databaseID: 1, // comment-tracker
  api: 'https://api.comment-tracker.esassoc.com/api/',
  //projectID: 1, // psp
  //projectID: 2, // capital lake
  //projectID: 4, // oakland
  //projectID: 5, // wind
  //projectID: 7, // cpuc
  //projectID: 8, // duck
  //projectID: 10, // seattle center
  //projectID: 11, //duck2
  //projectID: 12, //demo
  projectID: 16, // Medford Airport
  theme: 'esa',
  langs: ['en', 'sp'], // ['en', 'fr', 'ceb', 'zh', 'fil', 'hmn', 'ja', 'kh', 'ko', 'mo', 'sp', 'va']
  //serverUrl: "http://comment-tracker.esassoc.com/stage/tracker/seattlecenter"
  //serverUrl: "http://comment-tracker.esassoc.com/tracker/pugetsoundpartnership"
  //serverUrl: "http://comment-tracker.esassoc.com/tracker/capitollakewatershedeis"
  //serverUrl: "http://comment-tracker.esassoc.com/tracker/oaklandsportseir"
  //serverUrl: "http://comment-tracker.esassoc.com/tracker/fountainwindeir"
  // serverUrl: "http://comment-tracker.esassoc.com/tracker/tl6975"
  //serverUrl: "https://wdfw.wa.gov/species-habitats/habitat-recovery/nearshore/conservation/projects/duckabush"
  serverUrl: ""
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts